import { useTranslation } from "next-i18next";
import EachAttribute from "./EachAttribute";

const FilterableAttributes = (props: any) => {
  const { product } = props;
  const { filterableAttributes } = product;
  const {
    airFreshenerScent, merchandiseColor, merchandiseSize, airFreshenerColor,
  } = filterableAttributes || {};
  const { t } = useTranslation("common");

  return (
    <div className="d-flex flex-column">
      {merchandiseSize && (
        <EachAttribute title={t("Size")} value={merchandiseSize} />
      )}
      {merchandiseColor && (
        <EachAttribute title={t("Color")} value={merchandiseColor} />
      )}
      {airFreshenerScent && (
        <EachAttribute title={t("Scent")} value={airFreshenerScent} />
      )}
      {airFreshenerColor && (
        <EachAttribute title={t("Color")} value={airFreshenerColor} />
      )}
    </div>
  );
};

export default FilterableAttributes;
